<template>
  <div class="container bg-light my-3 py-3 px-4">

    <div class="row">
      <div class="col-12">
        <h2 class="ms-4 text-start">Create site type</h2>
        <hr>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site type name"
          placeholder="Name"
          @input="(e) => this.siteTypeInfo.type = e.target.value"
        /> 
      </div>
    </div>


    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="text"
          label="Enter site type description"
          placeholder="Description"
          @input="(e) => this.siteTypeInfo.description = e.target.value"
        /> 
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12 col-lg-6">
        <ca-smtt-input 
          type="number"
          label="Enter site type order"
          placeholder="Order"
          @input="(e) => this.siteTypeInfo.order = e.target.value"
        /> 
      </div>
    </div>

    <div class="row my-4">
      <div class="col-6 col-lg-3">
        <button class="btn btn-outline-primary w-100" @click="goBack">
          Dismiss
        </button>
      </div>
      <div class="col-6 col-lg-3">
        <button 
          :disabled="disableCreateButton"
          class="btn btn-primary w-100" 
          @click="handleCreateSiteType"
        >
          Create
        </button>
      </div>
    </div>

  </div>
</template>
<script>
import caSmttInput from '../../components/ca-smtt-input.vue'
import { createSiteType } from '../../services/sitesTypes/sites_types.api'

export default {
  data() {
    return {
      siteTypeInfo: {
        type: null,
        description: null,
        order: null
      },
    }
  },
  cumputed: {
    disableCreateButton() {
      return false
    }
  },
  methods: {
    async handleCreateSiteType() {
      try {
        await createSiteType(this.siteTypeInfo)
        this.$toast.open({
          message: 'Site Type Successfully Created',
          type: 'success'
        })
        this.$router.back()
      } catch (error) {
        console.log(error)
        this.$toast.open({
          message: 'An error occurred',
          type: 'error'
        })
      }
    },
    goBack() {
      this.$router.back()
    },
  },
  components: { caSmttInput },
  
}
</script>